import { Box, Button, Stack, Typography } from '@mui/material';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import { colors } from 'features/userData/style';

export default function UploadDropzone({
    getRootProps,
    getInputProps,
    isDragActive,
    onBrowseClick = null,
}) {
    const handleBrowse = (event) => {
        event.stopPropagation();
        onBrowseClick?.();
    };

    return (
        <Box
            {...getRootProps()}
            sx={{
                border: '1px dashed',
                borderColor: 'divider',
                p: 3,
                textAlign: 'center',
                mb: 3,
                cursor: 'pointer',
                borderRadius: 0,
                bgcolor: '#F7F7F7',
            }}
        >
            <input {...getInputProps()} />
            <Stack spacing={1.25} alignItems="center" textAlign="center">
                <Typography
                    sx={{
                        color: colors.lightGray,
                        fontSize: 12.5
                    }}
                >
                    {/* {isDragActive
                        ? '여기에 파일을 놓으세요.'
                        : 'Shapefile은 ZIP으로 묶어 업로드하고 CSV/XLS/XLSX도 지원합니다.'} */}
                    업로드할 파일을 여기에 끌어 놓거나, 파일 선택 버튼을 눌러 파일을 직접 선택해 주세요.
                </Typography>
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<UploadFileRoundedIcon />}
                    onClick={handleBrowse}
                    sx={{
                        fontWeight: 500,
                        borderColor: colors.darkBlue,
                        color: 'white',
                        bgcolor: colors.darkBlue,
                        px: 2,
                        py: 1,
                        boxShadow: 'none',
                        '&:hover': {
                            borderColor: colors.primaryBlue,
                            bgcolor: colors.primaryBlue,
                            boxShadow: 'none',
                        },
                    }}
                >
                    파일 선택
                </Button>
            </Stack>
        </Box>
    );
}
